import * as React from "react";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { ParagraphCustom, InputCustom, ButtonsCustom, TitleCustom, DatePickerCustom } from "../custom";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RestApiClientContext } from "src/hooks/context/pageContext";
import { Pagination } from "src/models/pagination/pagination";
import { CustomPagination } from "../utils/pagination/pagination";
import { TotalElementsTableList } from "../utils/totalElementsTableList/totalElementsTableList";
import { AutoComplete, Card, Divider, Modal, notification, Select, Skeleton, Tag, Tooltip } from "antd";
import { LangContext } from "src/hooks/context/lang";
import { API_URL_TEST, URL_IMAGE } from "src/constants/constants";
import { exportExcel } from "../utils/exportExcel/exportExcel";
import FileDownload from 'js-file-download';
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { PickerLocale } from "antd/lib/date-picker/generatePicker";
import moment, { Moment } from "moment";
import { getLocaleDatePicker } from "src/utils/datePicker";
import './rewardsEarned.sass';
import Button from "antd/es/button";
import { useLocation } from 'react-router-dom';

import { FormattedNumber } from "react-intl";
import { NotResults } from "../noResultGeneric/notResults";
export interface RewardFilter {
    rewardCode?: string;
    agentName?: string;
    agentEmail?: string;
    agentAgency?: string; // Guid se representa como string en TS
    agentUAID?: string;
    pagination?: Pagination;
    dateGenerated?: string;
    rewardSupplierName?: string;
    currency?: string;

}
export interface RewardEarned {
    id: string
    code: string
    dateGeneration: string
    agentName: string
    totalAmount: number
    currency: string
    isOwnReward: boolean
    image: string
    agentAmount: number
}

export default function RewardsEarned() {
    const { t } = useTranslation("rewards");
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const name = queryParams.get('name');
    const agencyIdParams = queryParams.get('agencyId')
    const agencyNameParams = queryParams.get('agencyName')
    const uaid = queryParams.get('uaid');
    const userLangContext = useContext(LangContext);
    const restApiClient = useContext(RestApiClientContext);
    const local: PickerLocale = getLocaleDatePicker();
    const [isLoading, setLoading] = useState(false);
    const [searchTermNameInput, setSearchTermNameInput] = useState<string>(name || "");
    const [searchTermEmailInput, setSearchTermEmailInput] = useState<string>("");
    const [searchCodeRewardInput, setSearchCodeRewardInput] = useState<string>("");
    const [searchTermUIDInput, setSearchTermUIDInput] = useState<string>(uaid || "");
    const [searchTermProveedorInput, setSearchTermProveedorInput] = useState<string>("");
    const [searchTermDateGeneratedInput, setSearchTermDateGeneratedInput] = useState<Moment | null>(null);
    const [searchTermAgency, setSearchTermAgency] = useState(agencyIdParams || "");
    const [agenciesList, setAgenciesList] = useState(null);
    const [currenciesList, setCurrenciesList] = useState<string[]>([]);
    const [searchTermCurrencyInput, setSearchTermCurrencyInput] = useState<string>("");
    const [searchTermLocationAgentInput, setSearchTermLocationAgentInput] = useState<string>("");
    const [pageResults, setPageResults] = useState<any>({ Page: 1, ResultPage: 10 });
    const [data, setData] = useState<{ totalRecord?: number, rewardsEarned?: RewardEarned[] } | null>(null);
    const [downloadingAgents, setDownloadingAgents] = useState<boolean>(false);
    const getRewardsFiltered = (filter: RewardFilter): void => {
        setLoading(true);
        restApiClient.getRewardsEearnedFiltered(filter)
            .then((data) => {
                setData(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }
    function searchCriteria() {
        const filter: RewardFilter = {
            agentName: searchTermNameInput,
            agentEmail: searchTermEmailInput,
            rewardCode: searchCodeRewardInput,
            pagination: pageResults,
            agentAgency: searchTermAgency,
            agentUAID: searchTermUIDInput,
            dateGenerated: searchTermDateGeneratedInput ? searchTermDateGeneratedInput.toISOString() : "",
            rewardSupplierName: searchTermProveedorInput,
            currency: searchTermCurrencyInput,
        }
        getRewardsFiltered(filter)
    }
    const getAgenciesList = (name?, results = 20) => {
        const filter = !name
            ? { page: 1, resultPage: results, language: userLangContext.GetLangContext(), address: searchTermLocationAgentInput }
            : { page: 1, resultPage: results, name: name, language: userLangContext.GetLangContext(), address: searchTermLocationAgentInput };
        restApiClient.getAgencies(filter).then((data) => {
            setAgenciesList(data);
        });
    };
    const sendExcel = async () => {
        try {
            setDownloadingAgents(true);

            const filter = {
                language: userLangContext.GetLangContext(),
                AgentName: searchTermNameInput,
                AgentEmail: searchTermEmailInput,
                RewardCode: searchCodeRewardInput,
                AgentAgency: searchTermAgency,
                AgentUAID: searchTermUIDInput,
                AgentLocation: searchTermLocationAgentInput,
                DateGenerated: searchTermDateGeneratedInput ? searchTermDateGeneratedInput.toISOString() : "",
                RewardSupplierName: searchTermProveedorInput,
            };

            const response = await exportExcel(`${API_URL_TEST}/Rewards/exportexcel`, filter);

            if (response.isFile) {
                FileDownload(response.data, t("earned.excel-name-file") + '.xlsx');
            } else {
                console.log(response.data);

                notification.error({
                    message: t("Error"),
                    description: response.data?.message || t("earned:error-excel"),
                })
            }

        } catch (error) {
            console.error(error);
            notification.error({
                    message: t("Error"),
                    description: t("earned:error-excel"),
                })
        } finally {
            setDownloadingAgents(false);
        }
    };
    const onSearch = async (searchText, results = 20) => {
        await getAgenciesList(searchText, results);
    };
    const confirm = (id: string) => {
        Modal.confirm({
            closable: true,
            title: t('earned.title-delete'),
            icon: <ExclamationCircleOutlined />,
            content: t('earned.content-delete'),
            okText: t('earned.confirm'),
            cancelText: t('earned.cancel'),
            onOk() {
                setLoading(true);
                restApiClient.deleteRewardEearned(id).then(() => {
                    searchCriteria()
                });
            }
        });
    };
    const handleChangeCheckinDate = (e) => {
        if (e !== null) {
            setSearchTermDateGeneratedInput(e);
        } else {
            setSearchTermDateGeneratedInput(null);
        }
    };
    useEffect(() => {
        getAgenciesList();
        restApiClient.getListCurrency().then((data) => {
            setCurrenciesList(data || []);
        });
    }, []);

    useEffect(() => {

        searchCriteria();
    }, [pageResults])

    return (
        <>
            <div className="col-12">
                <TitleCustom
                    level={1}
                    class="title-section"
                    text={t("earned.title")}
                />
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <ParagraphCustom
                        class={"p-0"}
                        text={t("earned.subtitle")}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <ButtonsCustom
                            id="btn-excel"
                            class={"button-agent-register"}
                            onClick={sendExcel}
                            content={
                                <div className="button-excel">
                                    {downloadingAgents ? <LoadingOutlined /> : <img src={URL_IMAGE + "excel-logo.svg"} />}
                                    <ParagraphCustom
                                        class={"mb-0 ml-1"}
                                        text={<>{t("earned.title")}</>}

                                    />
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div id="filters">
                <div className="col-12 mt-3">
                    <div className="row pr-3 pl-3 form-search-agency">
                        <div className="col-lg-3 label-left-search-lg">
                            <ParagraphCustom text={<strong>{t("earned.name-lastname")}</strong>} />
                            <InputCustom
                                id={"name"}
                                value={searchTermNameInput}
                                placeholder=""
                                className="main-input"
                                prefix={false}
                                allowClear={true}
                                classIcon={"search-agency-icon-input"}
                                icon={faSearch}
                                autoFocus={true}
                                onChange={(e) => setSearchTermNameInput(e.target.value)}
                            />
                        </div>
                        <div className="col-xs-12 col-lg-3 col-md-6 label-left-search">
                            <ParagraphCustom text={<strong>{t("earned.email")}</strong>} />
                            <InputCustom
                                id={"email"}
                                value={searchTermEmailInput}
                                placeholder=""
                                className="main-input"
                                classIcon={"search-agency-icon-input"}
                                prefix={false}
                                allowClear={true}
                                icon={faSearch}
                                onChange={e => setSearchTermEmailInput(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-3 label-left-search-lg">
                            <ParagraphCustom text={<strong>{t("earned.uid")}</strong>} />
                            <InputCustom
                                id={"uid"}
                                value={searchTermUIDInput}
                                placeholder=""
                                className="main-input"
                                prefix={false}
                                allowClear={true}
                                classIcon={"search-agency-icon-input"}
                                icon={faSearch}
                                autoFocus={true}
                                onChange={(e) => setSearchTermUIDInput(e.target.value)}
                            />
                        </div>

                        <div className="col-xs-12 col-lg-3 label-left-search-lg">
                            <ParagraphCustom text={<strong>{t("earned.code-reward")}</strong>} />
                            <InputCustom
                                value={searchCodeRewardInput}
                                id={"code-reward"}
                                placeholder=""
                                className="main-input"
                                classIcon={"search-agency-icon-input"}
                                prefix={false}
                                allowClear={true}
                                icon={faSearch}
                                onChange={e => setSearchCodeRewardInput(e.target.value)}
                            />
                        </div>
                        <div className="col-xs-12 col-lg-3 label-left-search-lg">
                            <ParagraphCustom text={<strong>{t("earned.agent-location")}</strong>} />
                            <InputCustom
                                value={searchTermLocationAgentInput}
                                id={"agent-location"}
                                placeholder=""
                                className="main-input"
                                classIcon={"search-agency-icon-input"}
                                prefix={false}
                                allowClear={true}
                                icon={faSearch}
                                onChange={e => setSearchTermLocationAgentInput(e.target.value)}
                            />
                        </div>
                        <div className="col-xs-12 col-lg-3 label-left-search">
                            <ParagraphCustom text={<strong>{t("earned.agency")}</strong>} />
                            <AutoComplete
                                showSearch
                                allowClear
                                defaultValue={agencyNameParams}
                                optionFilterProp="children"
                                className="col-12 main-select"
                                onSearch={(e) => onSearch(e, 20)}
                                onSelect={(e, opt) => {
                                    setSearchTermAgency(opt?.key);
                                }}
                                onChange={(v) => {
                                    if (!v || v.length == 0) {
                                        setSearchTermAgency('');
                                    }
                                }}
                                dropdownRender={(menu) => (
                                    <div>
                                        {menu}
                                        <Divider style={{ margin: "4px 0" }} />
                                        <span style={{ margin: "6px", display: "block" }}>{`${t(
                                            "earned.tooltip",
                                            {
                                                0: agenciesList?.totalRecord - 20 < 0 ? 0 : agenciesList?.totalRecord
                                            }
                                        )}`}</span>
                                    </div>
                                )}
                            >
                                {agenciesList?.agencies.map((opt) => (
                                    <Select.Option value={opt?.name} key={opt?.id}>
                                        {opt?.name}
                                        <Tooltip title={opt?.address}>
                                            <small style={{ display: "block" }}>{opt?.address}</small>
                                        </Tooltip>
                                    </Select.Option>
                                ))}
                            </AutoComplete>
                        </div>
                        <div className="col-xs-12 col-lg-3 label-left-search-lg">
                            <ParagraphCustom text={<strong>{t("earned.proveedor")}</strong>} />
                            <InputCustom
                                value={searchTermProveedorInput}
                                id={"code-reward"}
                                placeholder=""
                                className="main-input"
                                classIcon={"search-agency-icon-input"}
                                prefix={false}
                                allowClear={true}
                                icon={faSearch}
                                onChange={e => setSearchTermProveedorInput(e.target.value)}
                            />
                        </div>
                        <div className="col-xs-12 col-lg-3 label-left-search-lg">
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <div style={{ flex: 2, minWidth: 0 }}>
                                    <ParagraphCustom text={<strong>{t("earned.date-generation")}</strong>} />
                                    <DatePickerCustom
                                        format={local.dateFormat}
                                        locale={local}
                                        placeholder={local.lang.dateFormat}
                                        className="col-12 main-select"
                                        onChange={handleChangeCheckinDate}
                                    />
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <ParagraphCustom text={<strong>{t("earned.currency")}</strong>} />
                                    <Select
                                        allowClear
                                        showSearch
                                        className="col-12 main-select"
                                        value={searchTermCurrencyInput || undefined}
                                        onChange={(v) => setSearchTermCurrencyInput(v || "")}
                                    >
                                        {currenciesList.map((c) => (
                                            <Select.Option key={c} value={c}>{c}</Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'end' }} className="col-xs-12 col-lg-12 label-left-search-lg ">
                            <div style={{ paddingLeft: '10px', paddingRight: '0' }} className="col-lg-3 ">
                                <ButtonsCustom
                                    id="search-agency"
                                    class={"primary-button col-12"}
                                    type=""
                                    htmlType={null}
                                    onClick={searchCriteria}
                                    size={null}
                                    content={
                                        <span>
                                            <strong>{t("earned.search-button")}</strong>
                                        </span>
                                    }
                                />
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <Skeleton loading={isLoading} active>
                {data?.rewardsEarned?.length === 0 && <NotResults section="rewards" messageApi="" dataSearch={true} />}
                {data?.rewardsEarned && data.rewardsEarned.length > 0 && <div className="container-rewards col-12 pr-3 pl-3 ">
                    {data.rewardsEarned.map((user) => <>
                        <Card
                            style={{ boxShadow: '0 0 10px rgba(0,0,0,0.1)', borderRadius: '5px' }}
                            key={user.code}
                            bordered
                            title={<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                                <p style={{ textOverflow: "ellipsis", overflow: 'hidden', flex: 1, width: 250 }} className="text"><strong>{user.agentName}</strong></p>

                                <img style={{ maxHeight: '40px', maxWidth: '90px' }} src={user.image} alt={user.code} />
                            </div>} >
                            <div className="card-content">

                                <div >
                                    <p className="text">{t('earned.code-generation-date')}</p>
                                    <p className="text-bit-bolder">{moment(user.dateGeneration).format(local.dateTimeFormat)}</p>

                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '10px' }}>
                                    <div >
                                        <p className="text">{t('earned.code')}</p>
                                        <p className="text-bit-bolder">{user.code}</p>
                                    </div>



                                </div>
                            </div>
                            <Divider />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', width: "100%", justifyContent: 'space-between', flexDirection: 'row-reverse', flexWrap: 'wrap' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', width: "fit-content", }}>
                                        <strong style={{ fontSize: '18px' }} className="text-bit-bolder"> <FormattedNumber
                                            value={user.totalAmount}
                                            style="currency"
                                            currency={user.currency || "USD"}
                                        /></strong>

                                        <p className="text">{t('earned.total-amount')}</p>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', width: "fit-content" }}>
                                        <div style={{ display: 'flex' }}>
                                            <strong style={{ fontSize: '18px' }} className="text-bit-bolder"> <FormattedNumber
                                                value={user.agentAmount}
                                                style="currency"
                                                currency={user.currency || "USD"}
                                            /></strong>

                                        </div>
                                        <p className="text">{t('earned.total-won')}</p>
                                    </div>
                                </div>
                                {user.isOwnReward && <Button type="primary" onClick={() => confirm(user.id)}>{t('earned.devolution')}</Button>}
                            </div>


                        </Card>

                    </>
                    )}
                </div>}

            </Skeleton>
            {data?.totalRecord > 0 && <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }} className="col-12 p-0">
                <div style={{ marginBottom: '30px' }} className="p-0">
                    <TotalElementsTableList total={data.totalRecord} />
                </div>
                <div style={{ width: 'fit-content' }} className="p-0 pagination-container">
                    <CustomPagination
                        setPageResults={setPageResults}
                        pageResults={pageResults}
                        countData={data.totalRecord}
                        onChangeCallApi={(pagination) => setPageResults(pagination)}
                    />
                </div>
            </div>}
        </>
    );
}